const IOSIcon = () => {
  return (
    <svg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M13.7 3.547a3.001 3.001 0 0 1 2.8-1.922' stroke='var(--theme-primary, #810ea9)' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path
        clipRule='evenodd'
        d='M21.235 15.775c-.616 1.506-1.496 2.798-2.45 3.687-.872.811-1.806 1.288-2.66 1.288h-6.75c-2.625 0-6-4.5-6-9.375a5.625 5.625 0 0 1 9.375-4.192h0a5.626 5.626 0 0 1 8.172.715h0a4.501 4.501 0 0 0 .313 7.877h0z'
        stroke='var(--theme-primary, #810ea9)'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default IOSIcon;
